import * as angular from "angular";
import {IController} from "angular";

export class customerAddressesTableRowCtrl implements IController {

  address: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {

  }


}

angular
  .module('bringoz.admin.customers')
  .component('customerAddressesTableRow', {
    require: {
      customerAddressesTableCtrl: '^customerAddressesTable'
    },
    bindings: {
      address: '<'
    },
    template: require('./customer-addresses-table-row.html').default,
    controller: customerAddressesTableRowCtrl
  });
